<template>
  <div class="ad-preview-card">
    <router-link :to="{ name: 'AdDetails', params: { recordId: ad.recordId } }">
      <div class="bandeau position-absolute" :class="classStatus(ad.d_statut)"></div>
      <img :src="ad['ann_PHOP__Photo_estPrincipale::d_image']" :alt="ad['ann_PHOP__Photo_estPrincipale::d_imageAlt']">
      <div class="ad-card-content">
        <p class="ad-card-title">{{ ad.d_titre }}</p>
        <p class="ad-card-description" v-html="ad.d_descriptif"></p>
        <div class="ad-card-footer">
          <p class="ad-card-price">{{ parseInt(ad.d_prix).toLocaleString('fr-FR') + ' €' }}</p>
          <p class="ad-card-ref">Réf. {{ ad.d_reference }}</p>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'AdPreviewCard',
  props: {
    ad: Object
  },
  methods: {
    classStatus (value) {
      // "En vente" + "Sous offre" + "Sous compromis" + "Vendu"
      if (value !== '' && value !== undefined) {
        return this.$options.filters.camelCase(value)
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.ad-preview-card {
  width: 340px;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  margin: 10px;
  border-radius: 4px;
  color: #11264a;
  position: relative;
  overflow: hidden;

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &:hover {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
  }

  a:hover {
    text-decoration: none;
  }

  img {
    height: auto;
    max-height: 260px;
    object-fit: cover;
    border-radius: 4px 4px 0 0;
  }

  .ad-card-content {
    padding: 16px;
    text-align: start;
  }

  .ad-card-title {
    font-size: 14px;
    font-weight: 600;
    color: #ffb402;
    margin: 2px 0 3px 0;
  }

  .ad-card-description {
    max-height: 54px;
    overflow: hidden;
    font-size: 12px;
    margin: 4px 0 19px 0;
  }

  .ad-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ad-card-price {
      font-size: 24px;
      font-weight: bold;
      color: #11264a;
    }

    .ad-card-ref {
      font-size: 13px;
      font-weight: 600;
    }
  }

  .ad-card-description,
  .ad-card-ref {
    color: #11264a;
  }
}

.bandeau {
    transform: rotate(45deg); 
    position: absolute;
}
.bandeau.sousOffre {
    top: 2rem;
    right: -2rem;
}
.bandeau.sousCompromis {
    top: 3rem;
    right: -2rem;
}
.bandeau.vendu {
    top: 0.8rem;
    right: -2rem;
}
.bandeau::after {
    padding: 0rem 2rem !important;
}
.bandeau.sousOffre::after {
    content: 'Sous offre';
    background-color: yellow;
    color: black !important;
}
.bandeau.sousCompromis::after {
    content: 'Sous compromis';
    background-color: orange;
    color: white !important;
}
.bandeau.vendu::after {
    content: 'Vendu';
    background-color: red;
    color: white !important;
}
</style>